import { supplierIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

const CreateSupplierContactInput_ = z.object({
  name: z.string(),
  email: z.string().nullable(),
  phoneNumber: z.string().nullable(),
});

export const CreateSupplierContactInput: z.ZodType<CreateSupplierContactInput> =
  CreateSupplierContactInput_;
export interface CreateSupplierContactInput extends z.infer<
  typeof CreateSupplierContactInput_
> {}

const CreateSupplierInput_ = z.object({
  name: z.string(),
  street1: z.string().nullable(),
  street2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postalCode: z.string().nullable(),
  country: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  website: z.string().nullable(),
  currency: z.string().nullable(),
  productVendors: z.array(z.string()),
  leadTimeDays: z.number().nullable(),
  contacts: z.array(CreateSupplierContactInput).optional(),
  createFulfillmentLocation: z.boolean().optional(),
});

export const CreateSupplierInput: z.ZodType<CreateSupplierInput> =
  CreateSupplierInput_;
export interface CreateSupplierInput extends z.infer<
  typeof CreateSupplierInput_
> {}

export const createSupplier = {
  name: "createSupplier" as const,
  input: CreateSupplierInput,
  output: z.object({ supplierId: supplierIdFormat.schema }),
};
